import { DataTable } from "~/components/UpcomingDefaultsTable";
import { useLoanData } from "~/hooks/useLoanData";
import { useInfiniteGetActiveLoansByMaturityQuery } from "~/types/graphql";
import { useEffect } from "react";

export default function UpcomingDefaults() {
  const now = Math.floor(Date.now() / 1000);

  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useInfiniteGetActiveLoansByMaturityQuery(
      {
        first: 1000,
        skip: 0,
        date: now,
      },
      {
        getNextPageParam: (lastPage, allPages) => {
          // If we got less than the requested amount, there are no more pages
          if (lastPage.coolerLoans.length < 1000) {
            return undefined;
          }
          // Return the skip value for the next page
          return { skip: allPages.length * 1000 };
        },
        initialPageParam: { skip: 0 },
      }
    );

  // Automatically fetch next page when available
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const activeLoans = data?.pages.flatMap((page) => page.coolerLoans) ?? [];

  if (isLoading || !data) return <div>Loading...</div>;

  return (
    <div className="container mx-auto py-10">
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <h1 className="text-2xl font-bold">Active Loans</h1>
          <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
            Cooler V1
          </span>
        </div>
        <p className="text-muted-foreground">
          All currently active loans in the Cooler v1 protocol
        </p>
      </div>
      <DataTable
        data={activeLoans}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </div>
  );
}
